import { render, staticRenderFns } from "./PageConsoleDashboard.vue?vue&type=template&id=8b9795fe&scoped=true&"
import script from "./PageConsoleDashboard.vue?vue&type=script&lang=js&"
export * from "./PageConsoleDashboard.vue?vue&type=script&lang=js&"
import style0 from "./PageConsoleDashboard.vue?vue&type=style&index=0&id=8b9795fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b9795fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VContainer,VIcon})
